export default class TagOptions {

    source: string = 'partner';
    lang: string = 'en-GB';
    theme: string = '';
    hidePoweredBy: boolean = false;
    hideTicketDesc: boolean = false;
    displayWidgetHeader: boolean = true;
    showTypeFirst: boolean = false;
    defer: boolean = false;
    affiliateId: string = '';
    reppingId: string = '';
    presaleCode: string = '';
    trackingId: string = '';
    isModalMode: boolean = false;
    checkoutMode: string = 'modal';
    showWaitList: boolean = false;
    linkedOccurrences: boolean = true;
    poweredBy = {
        logo: "//static.designmynight.com/images/power-by-rebrand.svg",
        desc: 'Powered by DesignMyNight'
    };
    enableAnalyticsLinker: boolean = true;
    // widgetMode can also be list-view which renders the components in a list rather than routing to each one.
    widgetMode: string = 'default-view';
    listViewOpen: boolean = false;
    sortBy: string|boolean = 'next-date';
    occurrence: any = null;
    
    primary: string = '279EA4';
    primaryLight: string = '7DC5C8';
    secondary: string = '81368F';
    secondaryLight: string = 'B386BC';
    shade1: string = '333839';
    shade3: string = 'fff';
    background: string = '';
    checkoutVersion: string = '1';

    // Google Tag manager
    gtmClient?: string = undefined;
    gtmSession?: string = undefined;

    constructor (data: any) {
        for(let key in data) {
            let convertedName = this.kebabToCamelCase(key);

            switch(typeof (<any>this)[convertedName]) {
                case 'boolean':
                    (<any>this)[convertedName] = this.parseValue(data[key]);
                    break;
                default:
                    (<any>this)[convertedName] = data[key];
                    break;
            }
        }
    }

    private strToKebabCase (str: string): string {
        const regex = new RegExp('([a-z])([A-Z])', 'g');

        return str.replace(regex, '$1-$2').toLowerCase();
    }

    private strToCamelCase (str: string): string {
        const regex = new RegExp('(\-\w)', 'g');

        return str.replace(regex, start => start[1].toUpperCase());
    }

    private kebabToCamelCase (str: string): string {
        var find = /(\-\w)/g;

        var converter =  function(matches: any){
            return matches[1].toUpperCase();
        };

        var camelCaseString = str.replace(find, converter);

        return camelCaseString;
    }

    private parseValue(value: any) : any {
        switch (value) {
            case undefined:
                return undefined;

            case 'true':
                return true;

            case 'false':
                return false;

            default:
                return value;
        }
    }

    static readonly requiredFields: string[] = [
        'itemIds'
    ];
}
